module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"Average Occupancy Percentage":"平均混雑率","Max Occupancy":"最大滞在人数","Min Occupancy":"最小滞在人数","Average Occupancy":"平均混雑実数値"}}')
  delete Component.options._Ctor
}
